module.exports = __webpack_public_path__ + "media/images/new/icons/checkmark-black-45a364e21af6569a3f5f9bd66c3fba21.svg";